import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "customerSupportComponent text-center pt-4 pb-3 px-2" };
const _hoisted_2 = {
    key: 0,
    class: "font8-responsive"
};
const _hoisted_3 = { style: { "display": "flex", "justify-content": "space-evenly", "align-items": "center" } };
const _hoisted_4 = { class: "text-left mb-0 font6-responsive" };
import { ref } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CustomerSupportInfo',
    setup(__props) {
        const supportDelay = ref(true);
        return (_ctx, _cache) => {
            const _component_open_popup_button = _resolveComponent("open-popup-button");
            return (_openBlock(), _createElementBlock("article", _hoisted_1, [
                _cache[23] || (_cache[23] = _createElementVNode("h3", { class: "h4 mb-2" }, "Customer Support", -1)),
                (supportDelay.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
                        _cache[1] || (_cache[1] = _createTextVNode(" Aktuell kommt es zu einem stark erhöhtem Anrufaufkommen und damit zu längerer Wartezeit. Schreibe uns daher am besten eine E-Mail an ", -1)),
                        _createVNode(_component_open_popup_button, { "popup-name": "openContactPopup" }, {
                            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                    _createElementVNode("span", { class: "d-inline-block pointerhover text-underline" }, "support@myswooop.de", -1)
                                ]))]),
                            _: 1
                        }),
                        _cache[2] || (_cache[2] = _createTextVNode(" - wir melden uns schnellstmöglich bei dir zurück! ", -1))
                    ]))
                    : _createCommentVNode("", true),
                _cache[24] || (_cache[24] = _createElementVNode("p", { class: "mb-4" }, "Benötigst du unsere Unterstützung?", -1)),
                _createElementVNode("div", _hoisted_3, [
                    _cache[22] || (_cache[22] = _createElementVNode("img", {
                        src: "/images/_new_brand/customer_service_michelle_100x100.jpg",
                        width: "100",
                        height: "100",
                        alt: "Customer Service",
                        class: "mr-2 ml-md-3"
                    }, null, -1)),
                    _createElementVNode("p", _hoisted_4, [
                        (supportDelay.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _cache[4] || (_cache[4] = _createTextVNode(" Schreib Michelle: ", -1)),
                                _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                                _cache[6] || (_cache[6] = _createElementVNode("i", { class: "icon-brand_email" }, null, -1)),
                                _createVNode(_component_open_popup_button, { "popup-name": "openContactPopup" }, {
                                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                            _createElementVNode("span", { class: "pointerhover text-underline" }, "support@­myswooop.de", -1)
                                        ]))]),
                                    _: 1
                                }),
                                _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                                _cache[8] || (_cache[8] = _createElementVNode("i", { class: "icon-brand_clock" }, null, -1)),
                                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "d-inline-block" }, "Mo-Fr 09:00 -", -1)),
                                _cache[10] || (_cache[10] = _createTextVNode(" 17:00 ", -1))
                            ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _cache[12] || (_cache[12] = _createTextVNode(" Sprich mit Michelle: ", -1)),
                                _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
                                _cache[14] || (_cache[14] = _createElementVNode("i", { class: "icon-brand_email" }, null, -1)),
                                _createVNode(_component_open_popup_button, { "popup-name": "openContactPopup" }, {
                                    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                            _createElementVNode("span", { class: "pointerhover text-underline" }, "support@­myswooop.de", -1)
                                        ]))]),
                                    _: 1
                                }),
                                _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
                                _cache[16] || (_cache[16] = _createElementVNode("i", { class: "icon-brand_phone" }, null, -1)),
                                _cache[17] || (_cache[17] = _createElementVNode("a", {
                                    href: "tel:+49 (0) 421 98 96 87 0",
                                    title: "mySWOOOP Telefonnummer",
                                    class: "text-white"
                                }, " +49 (0)421­ 98 96 87 0 ", -1)),
                                _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
                                _cache[19] || (_cache[19] = _createElementVNode("i", { class: "icon-brand_clock" }, null, -1)),
                                _cache[20] || (_cache[20] = _createElementVNode("span", { class: "d-inline-block" }, "Mo-Fr 09:00 -", -1)),
                                _cache[21] || (_cache[21] = _createTextVNode(" 17:00 ", -1))
                            ], 64))
                    ])
                ])
            ]));
        };
    }
});
